import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch, RootState } from "./store";
import { db } from "../firebase";
import { doc, onSnapshot } from "firebase/firestore";

interface CheckoutSession {
  id: string;
  status: string;
  payment_status: string;
  payment_intent: string;
  client_secret: string;
  amount_total: number;
  currency: string;
  success_url: string;
  cancel_url: string;
  expires_at: number;
  mobile_config?: { method?: string; label?: string } | null;
  payment_method_types: string[];
  metadata?: Record<string, string>;
  line_items?: {
    data: {
      price_data?: {
        unit_amount: number;
        currency: string;
        product_data?: { name?: string };
      };
      quantity?: number;
    }[];
  };
}

interface PaymentsState {
  session: CheckoutSession | null;
  loading: boolean;
  error: string | null;
}

const initialState: PaymentsState = {
  session: null,
  loading: true,
  error:   null,
};

const paymentsSlice = createSlice({
  name: "payments",
  initialState,
  reducers: {
    setSession: (state, action: PayloadAction<CheckoutSession>) => {
      state.session = action.payload;
      state.loading = false;
      state.error   = null;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error   = action.payload;
      state.loading = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { setSession, setError, setLoading } = paymentsSlice.actions;
export default paymentsSlice.reducer;

export const listenToCheckoutSession = (sessionId: string | undefined) => (dispatch: AppDispatch) => {
  if (!sessionId) {
    dispatch(setError("No session ID in URL."));
    return () => {};
  }
  dispatch(setLoading(true));
  const ref = doc(db, "checkoutSessions", sessionId);
  return onSnapshot(
    ref,
    (snap) => {
      if (!snap.exists()) { dispatch(setError("Session not found.")); return; }
      const data = snap.data() as CheckoutSession;
      if (data.expires_at && data.expires_at < Math.floor(Date.now() / 1000)) {
        dispatch(setError("This session has expired.")); return;
      }
      dispatch(setSession(data));
      if (data.status === "complete") window.location.href = data.success_url;
    },
    (e) => dispatch(setError(e.message))
  );
};